import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {NotificationService} from '../../notification/notification.service';
import {NgxPermissionsService} from 'ngx-permissions';
import {OidcSecurityService} from 'angular-auth-oidc-client';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private readonly ns: NotificationService,
              private oidcSecurityService: OidcSecurityService,
              private readonly permissionsService: NgxPermissionsService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (typeof error.error === 'string') {
          this.ns.showErrorSnackBar(error.error);
        } else if (error.status === 401 || error.status === 403) {
          this.oidcSecurityService.logoffAndRevokeTokens()
            .subscribe(_ => {
              localStorage.clear();
              this.permissionsService.flushPermissions();
            });
        } else if (error.error?.Code === 412) {
          this.ns.showErrorSnackBar(error.error.Message[0], 0);
        } else if (error.error?.Message) {
          this.ns.showErrorSnackBar(error.error.Message[0]);
        } else if(error.url?.endsWith('News')) {
          return throwError(() => error); // Rethrow the error
        }

        return of(error);
      })
    );
  }
}
